<template>
  <v-container v-hotkey="keymap" id="login_page" class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-spacer />
          <v-toolbar flat>
            <v-toolbar-title>Демо-вхід в систему</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <v-form ref="form">
              <v-select
                v-model="selectedLesson"
                :items="lessons"
                label="Оберіть клас для демо-доступу"
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions id="login_button">
            <v-spacer />
            <v-btn :disabled="!selectedLesson" color="orange" @click="open"
              >Увійти</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      selectedLesson: '',
      lessons: [],
      uri: '/school/?demoToken=',
    };
  },

  mounted() {
    this.lessons = this.$_createLessons();
  },
  computed: {
    keymap() {
      return {
        enter: this.open,
      };
    },
    demoClassConfig() {
      return this.$store.getters['ConfigStore/getDemoClassConfig'];
    },
  },

  methods: {
    open() {
      window.location.href = `${this.uri}${this.selectedLesson}`;
    },
    $_createLessons() {
      return this.demoClassConfig.map((item) => {
        return {
          text: item.classLabel,
          value: item.token,
        };
      });
    },
  },
};
</script>
